import { render, staticRenderFns } from "./ProductTypeDetail.vue?vue&type=template&id=0f319c5f&scoped=true"
import script from "./ProductTypeDetail.vue?vue&type=script&lang=js"
export * from "./ProductTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeDetail.vue?vue&type=style&index=0&id=0f319c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f319c5f",
  null
  
)

export default component.exports